<template>
  <Layout />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Layout from "@/pages/Layout.vue";

@Options({
  components: {
    Layout,
  },
})
export default class App extends Vue {}
</script>
